import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import GenerateReport from 'pages/GenerateReport'

export const Route = createFileRoute('/_auth/projects/$id/generate-report')({
  beforeLoad: requireGlobalRole(
    GlobalRoleType.GLOBAL_VIEW,
    GlobalRoleType.GLOBAL_EDIT,
    GlobalRoleType.GLOBAL_ADMIN,
  ),
  component: GenerateReport,
})
